import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ROUTES } from '../../constants';
import Button from '../ui/Button';
import PageHero from '../ui/PageHero';

interface Section {
  heading: string;
  body: string;
}

interface LegalPageProps {
  title: string;
  lastUpdated: string;
  sections: Section[];
  metaTitle: string;
  metaDescription?: string;
}

export default function LegalPage({ title, lastUpdated, sections, metaTitle, metaDescription }: LegalPageProps) {
  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        {metaDescription && <meta name="description" content={metaDescription} />}
        <meta name="robots" content="noindex" />
      </Helmet>

      <PageHero title={title} lead={lastUpdated}>
        <Link to={ROUTES.HOME}>
          <Button variant="ghost" size="sm" iconLeft={<ArrowLeft size={15} />} className="mb-6 md:mb-8">
            Înapoi
          </Button>
        </Link>
      </PageHero>

      <div className="bg-white py-10 md:py-16">
        <div className="container max-w-3xl">
          {sections.map((s, i) => (
            <div key={i} className="mb-8 md:mb-10">
              <h2 className="font-syne text-navy font-bold text-lg md:text-xl mb-3">{s.heading}</h2>
              <p className="text-text-mid leading-relaxed text-[0.97rem]">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
